module.exports = __webpack_public_path__ + "static/media/squeezeballs.50b609c2.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/squeezeballs.wav
// module id = 517
// module chunks = 0